import { EnrollmentType, InstalledProductLine, InstalledProposal, InstalledRate } from 'types/enrollmentService';

export const getMaxRateCount = (installedProductLines: InstalledProductLine[], type: EnrollmentType): number => {
  const filterRateByType = (rates: InstalledRate[]): InstalledRate[] => {
    const currentRateField = type === EnrollmentType.RENEWAL ? 'renewalRate' : 'currentRate';
    return rates.filter((rate) => rate[currentRateField] && rate[currentRateField] !== 'N/A');
  };

  const rateCounts = installedProductLines
    .filter((pLineData) => pLineData.products.length === 1) // for multi products portfolio cards will be stretched vertically automatically
    .flatMap((pLineData) => pLineData.products)
    .map((product) => {
      return filterRateByType(product.rates).length;
    });
  return Math.max(...rateCounts);
};

export const hasMultiProductsPortfolio = (installedProposal: InstalledProposal): boolean => {
  return installedProposal?.productLines.some((plData) => plData.products.length > 1) || false;
};

export const hasRenewalRates = (productLineData: InstalledProductLine): boolean => {
  return productLineData.products.some((product) => product.rates.some(({ renewalRate }) => !!renewalRate));
};

export const effectiveThrough = (date: string): string => {
  const result = new Date(date);
  return new Date(result.setDate(result.getDate() - 1)).toLocaleDateString('en-US', { timeZone: 'UTC' });
};
